import { useEffect, useState } from 'react';

/**
 * The shared clock for anything that renders "how late is this" (breach badges).
 *
 * One interval per mounted caller, cleared on unmount — the queue mounts ONE of
 * these and hands the instant down to every row, so a fifty-row list carries one
 * timer, not fifty. 30 seconds because the badge renders whole minutes: any faster
 * only re-renders the same string.
 */
export function useNow(intervalMs = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
